import { render, staticRenderFns } from "./individual-hours-student-view.vue?vue&type=template&id=1affa3a4&"
import script from "./individual-hours-student-view.vue?vue&type=script&lang=js&"
export * from "./individual-hours-student-view.vue?vue&type=script&lang=js&"
import style0 from "./individual-hours-student-view.vue?vue&type=style&index=0&id=1affa3a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports